import { Directive, ElementRef, EventEmitter, Input, Output, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appSelect]'
})

export class SelectDirective{
  @Input() showSearchBar = false;
  @Output() emitSearch = new EventEmitter();
  @Input() set showing(value){
    if(value){
      if(this.showSearchBar && value){
        let attemps = 0;
        const interval = setInterval(() => {
          const alertWrp = document.querySelector('.alert-wrapper');
          if(attemps > 5) clearInterval(interval);
          if(alertWrp){
            clearInterval(interval);
            this.implementSearchbar(alertWrp);
          }
          attemps++;
        }, 50)
      }
    }
  }

  constructor(
    private el: ElementRef,
    private renderer: Renderer2
  ) {
  }

  implementSearchbar(alertWrp: Element){
    const searchInput = document.createElement('ion-searchbar');
    const existSearchInput = document.querySelectorAll('.search-alert');
    if(existSearchInput.length){
      existSearchInput.forEach(child => alertWrp.removeChild(child));
    }

    let alertRadioGroup = document.querySelector('.alert-radio-group');
    if(!alertRadioGroup) alertRadioGroup = document.querySelector('.alert-checkbox-group');
    else if(!alertRadioGroup) alertRadioGroup = document.querySelector('.alert-button-group');

    const options = document.querySelectorAll('.select-interface-option');
    this.renderer.addClass(searchInput, 'select-search')
    searchInput.classList.add('search-alert');
    searchInput.showClearButton = 'never';
    searchInput.placeholder = 'Buscar...';
    alertWrp.insertBefore(searchInput, alertRadioGroup);
    searchInput.addEventListener('input', (ev: any) => {
      const search: string = ev.target.value.toLowerCase();
      this.emitSearch.emit(search);
      options.forEach((item) => {
        const txt = item.children[0].children[1]?.childNodes[0].textContent.toLocaleLowerCase().trim();
        if(!txt) return false;
        let value = '';
        if(!txt.includes(search)){
          value = 'none';
        }else{
          value = 'inline-block';
        }
        this.renderer.setStyle(item, 'display', value);
      })
    })
  }

}
